import { isMaster } from "../../../utils/checkPermission";
import { ErrorAccessDenied } from "../Error";
import { DuplicatePeriodsReview } from "../../../components/Admin/DataIntegrity/DuplicatePeriodsReview";
import { useLanguage } from "../../../contexts";
import { useAuth } from "../../../hooks";
import { Header, Segment } from "semantic-ui-react";
import "./DuplicatePeriods.scss";

export function DuplicatePeriods() {
  const {
    user: { role },
  } = useAuth();

  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  if (isMaster(role)) {
    return (
      <div className="duplicate-periods-page">
        <Segment className="duplicate-periods-page__title">
          <Header as="h1">{t("duplicate_periods")}</Header>
        </Segment>
        <DuplicatePeriodsReview />
      </div>
    );
  }

  return <ErrorAccessDenied />;
}
